import { baseUrl } from '@cxnpl/api/baseUrl';
import { useSearchParams } from 'solito/navigation';

export function Auth0LoginPage() {
  const params = useSearchParams();
  const redirectParams = params?.get('redirect');
  const redirectUri = redirectParams
    ? encodeURIComponent(`${process.env.ORIGIN_HEADER}/${decodeURIComponent(redirectParams)}`)
    : encodeURIComponent(`${process.env.ORIGIN_HEADER}/home`); // Redirect home in failcase

  /**
   * Majority of heavy lifting is handled by the cxnpl backend.
   * Just move from this page to a different page.
   *  */
  window.location.href = `${baseUrl}/v2/session/web-login?redirectUri=${redirectUri}`;

  return <></>;
}
